import { render } from "./AccountingModule.vue?vue&type=template&id=7c89dbdf&scoped=true"
import script from "./AccountingModule.vue?vue&type=script&lang=js"
export * from "./AccountingModule.vue?vue&type=script&lang=js"

import "./AccountingModule.vue?vue&type=style&index=0&id=7c89dbdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c89dbdf"]])

export default __exports__